/* eslint-disable */
import {
  Button,
  Checkbox,
  message,
  Modal,
  Form,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "@/common.css";
import {
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import commonFn from "@/utils/commonFn";
import MainTable from "./component/MainTable";
import NewModal from "./component/NewModal"
import { CustomTableExtend } from "@/hocComponents";

export default function UtilityPayment() {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKeyNewModal, setRefreshKeyNewModal] = useState(0);
  const childRef = useRef();

  //调用子组件showCompare方法
  const showCompare = () => {
    if (childRef.current) {
      childRef.current.showCompare();
    }
  };
  //删除接口
  const delfun = async (ids) => {
    const response = await http.post(`${api.UtilPaymentDel}`, {ids});
    if(response.code === '1'){
      message.success("Successfully Deleted");
      childRef.current.fetchDataFn();
    }
  };
  //删除
  const deleteFn = (record) => {
    Modal.confirm({
      title: "Delete Reminder",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to delete the selected data?",
      okText: "Sure",
      cancelText: "Cancel",
      onOk() {
        delfun([record.vendorUtilPaymentId]);
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };

  // 处理子组件NEW 组件
  //调用子组件showModal方法
  const showModal = () => {
    setSelectedRecord({});
    setRefreshKeyNewModal(+new Date())
    setOpen(true);
  };

  const handleSubmit = () => {
    childRef.current.fetchDataFn();
  }
  const handleCancel = () => {
    setOpen(false);
  };
 
  // 修改modal
  const handleOpenModal = (e, record) => {
    if(e.key === 'edit'){
      setSelectedRecord(record);
      setRefreshKeyNewModal(+new Date())
      setOpen(true);
    }else if(e.key === 'delete'){
      deleteFn(record)
    }
  };

  const downLoadFn = async() => {
    const tableHead = childRef.current.getTableHead();
    const blob = await http.get(api.UtilPaymentExport, {params: tableHead, responseType: 'blob'});
    return {
      blob,
      name: `Utility_Payment`
    }
  }
  
  return (
    <div>
      <CustomTableExtend
        // columns={childRef.current?.getColumns()}
        // setColumns={childRef.current?.setColumnsFn()}
        // initColumns={childRef.current?.getInitColumns()}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download', 'columnList']}
        downLoadFn={() => downLoadFn()}
      >
        <div className="topLeft">
          {commonFn.btnAuthorityFlag('New') && <Space size="large">
            <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
              New
            </Button>
          </Space> || null}
          {commonFn.btnAuthorityFlag('Compare') && <Button className="btnCompare"  onClick={showCompare}>
            Compare
          </Button> || null}
        </div>
      </CustomTableExtend>
      <MainTable refreshKey={refreshKey} ref={childRef} onMenuClick={handleOpenModal}></MainTable>
      <NewModal
        refreshKeyNewModal={refreshKeyNewModal}
        open={open}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        form={form}
        record={selectedRecord}
      />
    </div>
  );
}
